import isClient from './util/detectClient';
import {ajax} from './util/request';
import {documentVisibilityChange} from './util/config';
import {isInGaoTuAndroidApp, isInGaoTuIOSApp, isTestReg} from './util/env';
import debounce from './util/debounce';
import {on} from './util/dom';
import {parse as parseQuery} from './util/json';
import onRouteChange from './util/onRouteChange';
import {isPlainObj} from './util/appCommonParam';
import {detectStorage} from './util/detectStorageAvailability';
import {isInGaoTuApp} from './util/env';

const CAN_I_USE_STORE = detectStorage();
const commonFields = ['version', 'p_client', 'os'];
let connectUUId = '';
let getCompassConfigApi = '';
let postPageConfig = '';
// 罗盘对H5页面的类型标记为2，客户端为1
const H5PageType = '2';

const pageShowEventId = '10299178009782272';
let compassBPConfig = {};
let clientInfo = {};


/**
 * 初始化上报相关参数和变量，否则服务端渲染会导致部分变量取不到报错
 */
function initTrackCtx() {
    const isTestEnv = isTestReg.test(location.host) ? 'test-' : '';
    getCompassConfigApi = `https://${isTestEnv}compass-api.baijia.com/compass-api/ext/api/getCompassBPConfig`;
    postPageConfig = `https://${isTestEnv}compass.baijia.com/compass/api/extApi/bpAppDataUpload`;
    initClientInfo();
}

/**
 * 保存一下当前接口需要的客户端信息
 */
function initClientInfo() {
    const queryObj = parseQuery(location.search.slice(1));
    commonFields.forEach(key => {
        clientInfo[key] = queryObj[key];
    });

    if (CAN_I_USE_STORE) {
        if (clientInfo.version && clientInfo.p_client && clientInfo.os) {
            localStorage.setItem('clientInfo', JSON.stringify(clientInfo));
        }
        else {
            try {
                clientInfo = JSON.parse(localStorage.getItem('clientInfo')) || {};
            }
            catch (e) {
                console.error('localStorage.getItem("clientInfo") err', e);
            }
        }

        // connectUUId 用来标识罗盘开启了配置模式
        connectUUId = queryObj.connectUUId || sessionStorage.getItem('connectUUId') || '';

        if (connectUUId) {
            sessionStorage.setItem('connectUUId', connectUUId);
        }
    }
}


/**
 * 将url中的path 进行压缩，将动态参数（数字）进行统一替换，变成一条路由  /category/22 /category/23 => /category/*
 * 如果有非数字的动态参数（/staticpathname/dynamicParam1/dynamicParam2），暂不处理
 *
 * @param {string} path 当前页面的pathname
 */
function compressPath(path = location.pathname) {
    return location.pathname.split('/').map(part => ((part && /\d+/.test(part)) ? '*' : part))
        .join('/');
}

/**
 * 通过接口获取所有H5项目页面的配置信息
 */
function getCompassTrackConfig() {
    try {
        compassBPConfig = isPlainObj(compassBPConfig)
            ? compassBPConfig
            : (detectStorage('sessionStorage') ? (JSON.parse(sessionStorage.getItem('CompassBPConfig')) || {}) : {});
    }
    catch (e) {
        console.warn('getCompassTrackConfig', e);
    }

    // 如果本地还存在配置，则不会再取一次了
    if (isPlainObj(compassBPConfig)) {
        return;
    }

    // 在客户端内，且有合法的配置信息
    if (clientInfo.p_client && clientInfo.version && clientInfo.os) {
        ajax({
            url: getCompassConfigApi,
            method: 'POST',
            headers: {'content-type': 'application/json'},
            data: {
                pageType: H5PageType,
                pOs: clientInfo.os,
                pClient: clientInfo.p_client,
                pVersion: clientInfo.version,
                configVersion: '1'
            }
        }).then(response => {
            const {data = {}, code = 0} = response;
            if (+code === 0) {
                compassBPConfig = data;
                sessionStorage.setItem('CompassBPConfig', JSON.stringify(data));
            }
        }).catch(e => {
            console.warn('getCompassConfigApi data e', e);
        });
    }
}


/**
 * 配置模式下，上报页面的信息给罗盘
 */
function uploadPageInfoToCompass() {
    if (connectUUId) {
        // 实时获取页面query
        const queryObj = parseQuery(location.search.slice(1));
        const dynamicProperties = Object.keys(queryObj).map(key => ({propertyName: `${key}`}));

        window.compassTrackScreenShotCallback = res => {
            try {
                const {img_url} = res;
                if (img_url) {


                    ajax({
                        method: 'POST',
                        url: postPageConfig,
                        headers: {'content-type': 'application/json'},
                        data: {
                            data: {
                                pageType: H5PageType,
                                imgUrl: img_url,
                                dynamicProperty: dynamicProperties,
                                // [
                                // 暂不支持下面上报方式
                                // {
                                //     "page" : {
                                //         propertyName : '页面来源',
                                //         propertyPath: 'subject.subjhectid'
                                //     }
                                // },

                                // 先支持下面的上报动态属性信息方式
                                // {
                                //     propertyName: "isNavigaitonLeftButtonClose"
                                // }
                                // ],
                                pageName: document.title,
                                clientPagePath: location.host + compressPath()
                            },
                            uuid: connectUUId
                        }
                    }).then(response => {
                        if (response?.code !== 0) {
                            // eslint-disable-next-line no-alert
                            alert(res.msg);
                            sessionStorage.removeItem('connectUUId');
                        }
                    }).catch(e => {
                        console.warn('uploadPageInfoToCompass data e', e);
                    });
                }
            }
            catch (e) {
                console.log('compassTrackScreenShotCallback img err ', e);
            }
        };

        postMessageToNative({
            type: 'screenshot'
        });
    }
}

/**
 * 根据客户端类型来判断使用什么样的端能力来上报页面展现和停留信息
 */
function postMessageToNative(json = {}) {
    if (isInGaoTuAndroidApp) {
        window.hubbleDataNativeTracker?.trackFromH5WithEvent?.(JSON.stringify(json));
    }
    else if (isInGaoTuIOSApp) {
        window.webkit?.messageHandlers?.hubbleDataNativeTracker?.postMessage?.(JSON.stringify(json));
    }
}

/**
 * 发送展现日志
 */
function sendPVTrackLog() {
    if (document.visibilityState !== 'visible') {
        return;
    }

    const {page = {}} = compassBPConfig;
    const currentPath = location.host + compressPath();
    // 默认上报每个页面的展现日志，除非配置不上报
    if (page[currentPath] && page[currentPath].pageViewEnable === false) {
        return;
    }

    const {customParam = {}, pageParam = {}} = page[currentPath] || {};
    const querys = parseQuery(location.search.slice(1));
    // 动态参数这里规则有点复杂
    // 接口数据 pageParam: {grade: {propertyName: "年级", propertyPath: "gradepath"}}
    // propertyPath 为自定义的取值的路径，需要开发伙伴协同配置才可以，目前H5支持的动态参数都是url上的query，以后可能会支持从页面的元素中取值，需要提前定义好规则
    // 比如 规则一 [url.query]
    // 比如 规则二 [$('.xxx')]
    // 以上规则等待后续拓展
    // 目前只默认支持从 query 中取值
    const dynamicProperties = Object.keys(pageParam).map(logKey => ({logKey: querys[logKey]})) || [{}];

    // 调用端能力上报日志
    postMessageToNative({
        type: 'pv',
        data: {
            // eslint-disable-next-line quote-props
            'event_id': pageShowEventId,
            track_page_path: location.host + compressPath(),
            track_web_url: location.href,
            track_page_title: document.title,
            ...customParam,
            ...dynamicProperties
        }
    });
}


/**
 * 开始配置
 */

const debouncedSendPVTrackLog = debounce(sendPVTrackLog);

function startTrack() {
    if (isClient && isInGaoTuApp) {
        initTrackCtx();
        getCompassTrackConfig();

        on(document, documentVisibilityChange, e => {
            sendPVTrackLog();
        });

        onRouteChange(e => {
            debouncedSendPVTrackLog();
            // 配置模式才会上报
            uploadPageInfoToCompass();
        });

        // 页面初始化后立马上报一次展现日志
        // 暂不考虑监听 visibilitychange 事件，多次上报展现日志
        if (document.visibilityState === 'visible') {
            debouncedSendPVTrackLog();
        }
        // 配置模式启动
        uploadPageInfoToCompass();
    }
}

export default startTrack;
